<template lang="html">
	<table
		class="wp-list-table"
		:class="{
			widefat : widefat,
			fixed   : fixed,
			striped : striped,
		}"
	>
		<thead v-if="headers">
			<tr>
				<th v-if="doSelectAll" class="checkbox-cell">
					<input-checkbox
						class="select-all"
						:checked="isSelectAll"
						@input="changeSelectAll"
						v-if="canDoBulk"
					/>
				</th>
				<th
					v-for="header in headers"
					:key="header.name"
					:class="header.class"
					v-html="header.name"
				/>
			</tr>
		</thead>
		<tbody>
			<tr v-if="isLoading">
				<td :colspan="headerCount">
					<core-loading size="44px"/>
				</td>
			</tr>
			<!-- @slot Table Data -->
			<slot v-else>
				<tr>
					<td :colspan="headerCount">
						<slot name="no-data">No data found.</slot>
					</td>
				</tr>
			</slot>
		</tbody>
		<tfoot v-if="headers && showFooter">
			<tr>
				<th v-if="doSelectAll" class="checkbox-cell">
					<input-checkbox
						class="select-all"
						:checked="isSelectAll"
						@input="changeSelectAll"
						v-if="canDoBulk"
					/>
				</th>
				<th
					v-for="header in headers"
					:key="header.name"
					:class="header.class"
					v-html="header.name"
				/>
			</tr>
		</tfoot>
	</table>
</template>

<script lang="js">
import { mapActions, mapGetters, mapState } from 'vuex'
/**
 * Base Table Container
 * @displayName Base Table Container
 * @since 2.0.0
 */
export default {
	name  : 'TableBase',
	props : {
		/**
		 * The table headers.
		 */
		headers : {
			type    : Array,
			default : () => [],
		},
		/**
		 * Show the table footer.
		 * @values true, false
		 */
		showFooter : {
			type    : Boolean,
			default : true,
		},
		/**
		 * Is the data still being loaded?
		 * @values true, false
		 */
		isLoading : {
			type    : Boolean,
			default : true,
		},
		/**
		 * Can a user select all table items?
		 * @values true, false
		 */
		doSelectAll : {
			type    : Boolean,
			default : true,
		},
		/**
		 * Whether table is widefat.
		 *
		 * @type {Boolean}
		 */
		widefat : {
			type    : Boolean,
			default : true,
		},
		/**
		 * Whether table layout is fixed.
		 *
		 * Table and column widths are set by the widths of table and col elements
		 * or by the width of the first row of cells. Cells in subsequent rows
		 * do not affect column widths.
		 *
		 * @link https://developer.mozilla.org/en-US/docs/Web/CSS/table-layout
		 *
		 * @type {Boolean}
		 */
		fixed : {
			type    : Boolean,
			default : true,
		},
		/**
		 * Whether table is striped.
		 *
		 * @type {Boolean}
		 */
		striped : {
			type    : Boolean,
			default : true,
		},
	},
	mounted () {

	},
	methods : {
		...mapGetters([ 'allowed' ]),
		...mapGetters('campaigns', [ 'canBulk' ]),
		...mapActions('campaigns', [ 'selectAll', 'deSelectAll' ]),
		changeSelectAll (value, checked) {
			if (checked) {
				this.selectAll()
			} else {
				this.deSelectAll()
			}
		},
	},
	computed : {
		...mapState('campaigns', [ 'isSelectAll' ]),
		/**
		 * Get the number of table headers.
		 * @returns {number} total number of headers
		 */
		headerCount () {
			return this.doSelectAll ? this.headers.length + 1 : this.headers.length
		},
		/**
		 * Whether user can do bulk actions.
		 *
		 * @returns {number} total number of campaigns the user can bulk edit
		 */
		canDoBulk () {
			return this.allowed('roles', 'bulk.select')
		},
	},
}
</script>

<style lang="scss" scoped>
	.om-circle-loading {
		margin: 10px auto;
	}
	.checkbox-cell {
		width: 25px;
	}
	.form-checkbox-no-label, .form-checkbox-no-label .form-checkbox-wrapper {
		display: block;
	}
</style>
